import { HttpErrorResponse } from '@angular/common/http';

/* Error preventivo que debe ser capturado */
export class ErrorFrontend extends Error {
  constructor(datos: any) {
    if (typeof datos === 'string') {
      super(datos);
    } else if (datos instanceof HttpErrorResponse) {
      const error =
        datos.error instanceof Blob ? blobToJson(datos.error) : datos.error;
      if (error?.detail) super(error.detail);
      else if (error?.message) super(error.message);
      else if (error?.error) super(error.error);
      else if (error) super(JSON.stringify(error, null, 2));
      else super('Error desconocido');
    } else if (typeof datos === 'object') {
      super(JSON.stringify(datos, null, 2));
    } else {
      super('Error desconocido');
    }
  }
}

/* Error de desarrollo (para alertar al desarrollador) */
export class ErrorDesarrollo extends Error {
  constructor(mensaje: string) {
    const mensajeFinal =
      '\n' + mensaje + '\nPor favor, contacte a soporte técnico.';
    super(mensajeFinal);
  }
}

/**
 * Convierte un Blob a JSON.
 * @param {Blob} blob - El Blob a convertir.
 * @returns {Object} - El JSON resultante.
 * @author Juan Corral
 */
function blobToJson(blob: Blob) {
  const xhr = new XMLHttpRequest();
  const url = URL.createObjectURL(blob);
  xhr.overrideMimeType('text/plain; charset=x-user-defined');
  xhr.open('GET', url, false);
  xhr.send();
  const uint8 = Uint8Array.from(xhr.response, (c: any) => c.charCodeAt(0));
  const text = new TextDecoder().decode(uint8);
  const arrayBuffer = uint8.buffer;
  const json = JSON.parse(text);
  return json;
}
